var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _g2, _path14, _g3, _path15, _g4, _g5, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmptyBox = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 137,
    viewBox: "0 0 186 137",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.67 59.5571C151.67 72.7848 147.241 85.2143 139.859 95.021C135.77 100.381 130.887 105.056 125.209 108.705C116.123 114.749 105.108 118.17 93.4103 118.17C61.2711 118.284 35.1509 92.0562 35.1509 59.5571C35.1509 27.172 61.1575 0.830566 93.4103 0.830566C105.108 0.830566 116.01 4.25153 125.209 10.2952C130.887 13.9442 135.77 18.6196 139.859 23.9791C147.241 33.8998 151.67 46.2153 151.67 59.5571Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0415 51.7048H48.3382C47.8107 51.7048 47.459 51.5407 47.459 51.2946C47.459 51.0484 47.8107 50.8843 48.3382 50.8843H49.0415C49.569 50.8843 49.9206 51.0484 49.9206 51.2946C49.9206 51.5407 49.569 51.7048 49.0415 51.7048Z",
    fill: "#2D5887"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0415 54.9871H48.3382C47.8107 54.9871 47.459 54.823 47.459 54.5768C47.459 54.3306 47.8107 54.1665 48.3382 54.1665H49.0415C49.569 54.1665 49.9206 54.3306 49.9206 54.5768C49.9206 54.823 49.569 54.9871 49.0415 54.9871Z",
    fill: "#2D5887"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0415 58.2693H48.3382C47.8107 58.2693 47.459 58.1052 47.459 57.859C47.459 57.6128 47.8107 57.4487 48.3382 57.4487H49.0415C49.569 57.4487 49.9206 57.6128 49.9206 57.859C49.9206 58.1052 49.569 58.2693 49.0415 58.2693Z",
    fill: "#2D5887"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0415 61.5515H48.3382C47.8107 61.5515 47.459 61.3874 47.459 61.1412C47.459 60.8951 47.8107 60.731 48.3382 60.731H49.0415C49.569 60.731 49.9206 60.8951 49.9206 61.1412C49.9206 61.3874 49.569 61.5515 49.0415 61.5515Z",
    fill: "#2D5887"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1409 51.7048H69.5749C69.106 51.7048 68.7935 51.5407 68.7935 51.2946C68.7935 51.0484 69.106 50.8843 69.5749 50.8843H81.1409C81.6097 50.8843 81.9223 51.0484 81.9223 51.2946C81.9223 51.5407 81.6097 51.7048 81.1409 51.7048Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.784 61.5515H69.5484C69.0954 61.5515 68.7935 61.3874 68.7935 61.1412C68.7935 60.8951 69.0954 60.731 69.5484 60.731H105.784C106.237 60.731 106.539 60.8951 106.539 61.1412C106.539 61.3874 106.237 61.5515 105.784 61.5515Z",
    fill: "url(#paint0_linear_11941_52832)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1862 54.9871H65.4273C64.9855 54.9871 64.6909 54.8229 64.6909 54.5768C64.6909 54.3306 64.9855 54.1665 65.4273 54.1665H81.1862C81.628 54.1665 81.9226 54.3306 81.9226 54.5768C81.9226 54.8229 81.628 54.9871 81.1862 54.9871Z",
    fill: "#2D5887"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4961 58.2693H65.4257C64.9848 58.2693 64.6909 58.1052 64.6909 57.859C64.6909 57.6128 64.9848 57.4487 65.4257 57.4487H93.4961C93.937 57.4487 94.2309 57.6128 94.2309 57.859C94.0839 58.1052 93.79 58.2693 93.4961 58.2693Z",
    fill: "#2D5887"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.74 58.2693H95.0302C94.5506 58.2693 94.231 58.1052 94.231 57.859C94.231 57.6128 94.5506 57.4487 95.0302 57.4487H105.74C106.22 57.4487 106.539 57.6128 106.539 57.859C106.539 58.1052 106.22 58.2693 105.74 58.2693Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.328 58.2693H108.136C107.67 58.2693 107.36 58.1052 107.36 57.859C107.36 57.6128 107.67 57.4487 108.136 57.4487H112.328C112.793 57.4487 113.104 57.6128 113.104 57.859C113.104 58.1052 112.793 58.2693 112.328 58.2693Z",
    fill: "url(#paint1_linear_11941_52832)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.022 103.4H159.875",
    stroke: "#D6DEE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11941_52832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.847 50.8843V103.4H44.3932C41.4562 103.4 39.2534 101.04 39.2534 98.2367V50.8843H118.847Z",
    fill: "white"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M148.388 50.8843V98.2367C148.388 101.187 145.939 103.4 143.031 103.4H118.848V50.8843H148.388Z",
    fill: "#DAE1ED"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_11941_52832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.388 50.8843V98.2367C148.388 101.187 145.939 103.4 143.031 103.4H118.848V50.8843H148.388Z",
    fill: "#E7EAF4"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9731 50.8842L83.6293 26.2676H163.978L147.879 50.8842H67.9731Z",
    fill: "#C5CDDB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_11941_52832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.9731 50.8842L83.6293 26.2676H163.978L147.879 50.8842H67.9731Z",
    fill: "url(#paint2_linear_11941_52832)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M148.388 51.0281V78.7831H126.848C124.848 78.7831 123.463 77.4889 123.156 75.6194L118.848 50.8843L148.388 51.0281Z",
    fill: "url(#paint3_linear_11941_52832)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_11941_52832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.769 50.8843H118.848L133.533 73.1424C134.582 74.6165 136.23 75.5009 137.879 75.5009H160.356C161.855 75.5009 162.904 73.7321 162.004 72.5528L147.769 50.8843Z",
    fill: "url(#paint4_linear_11941_52832)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_11941_52832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.847 50.8842L103.082 26.2676H22.022L38.3826 50.8842H118.847Z",
    fill: "#E7EAF4"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9763 81.2449H47.9438C47.2187 81.2449 46.6387 80.6978 46.6387 80.014C46.6387 79.3302 47.2187 78.7832 47.9438 78.7832H78.9763C79.7014 78.7832 80.2814 79.3302 80.2814 80.014C80.1364 80.6978 79.7014 81.2449 78.9763 81.2449Z",
    fill: "#DAE1ED"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9763 86.9888H47.9438C47.2187 86.9888 46.6387 86.6241 46.6387 86.1682C46.6387 85.7123 47.2187 85.3477 47.9438 85.3477H78.9763C79.7014 85.3477 80.2814 85.7123 80.2814 86.1682C80.1364 86.6241 79.7014 86.9888 78.9763 86.9888Z",
    fill: "#DAE1ED"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5448 93.5532H47.9642C47.2278 93.5532 46.6387 93.1885 46.6387 92.7327C46.6387 92.2768 47.2278 91.9121 47.9642 91.9121H62.5448C63.2812 91.9121 63.8703 92.2768 63.8703 92.7327C63.723 93.1885 63.1339 93.5532 62.5448 93.5532Z",
    fill: "#DAE1ED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11941_52832",
    x: 17.2534,
    y: 39.8843,
    width: 123.594,
    height: 96.5156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11941_52832"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11941_52832",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_11941_52832",
    x: 96.8477,
    y: 39.8843,
    width: 73.54,
    height: 96.5156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11941_52832"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11941_52832",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_11941_52832",
    x: 45.9731,
    y: 15.2676,
    width: 140.005,
    height: 68.6167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11941_52832"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11941_52832",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_11941_52832",
    x: 96.8477,
    y: 39.8843,
    width: 87.4893,
    height: 68.6167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11941_52832"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11941_52832",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_11941_52832",
    x: 0.0219727,
    y: 15.2676,
    width: 140.826,
    height: 68.6167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11941_52832"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11941_52832",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11941_52832",
    x1: 68.963,
    y1: 61.1579,
    x2: 106.583,
    y2: 61.1579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11941_52832",
    x1: 107.398,
    y1: 57.8339,
    x2: 113.103,
    y2: 57.8339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11941_52832",
    x1: 115.944,
    y1: 25.6982,
    x2: 115.944,
    y2: 51.1496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11941_52832",
    x1: 133.624,
    y1: 79.3558,
    x2: 133.624,
    y2: 53.9432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAB2C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11941_52832",
    x1: 140.578,
    y1: 50.3149,
    x2: 140.578,
    y2: 75.7663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyBox, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty-box.9f529425.svg";
export { ForwardRef as ReactComponent };